import { render } from "./UiButton.vue?vue&type=template&id=6e12d786&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=6e12d786&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=1&id=6e12d786&scoped=true&lang=css&external"

import exportComponent from "../../../../../../Users/cole/Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e12d786"]])

export default __exports__